import { AxiosRequestConfig, AxiosResponse } from 'axios';
import axiosInstance from './axios-instance';
import { ApiResponse } from '@/types';

/**
 * Cliente HTTP genérico
 */
class ApiClient {
  /**
   * GET request
   */
  async get<T = any>(url: string, config?: AxiosRequestConfig): Promise<T> {
    const response: AxiosResponse<ApiResponse<T>> = await axiosInstance.get(url, config);
    return response.data.data;
  }

  /**
   * POST request
   */
  async post<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
    const response: AxiosResponse<ApiResponse<T>> = await axiosInstance.post(url, data, config);
    return response.data.data;
  }

  /**
   * PUT request
   */
  async put<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
    const response: AxiosResponse<ApiResponse<T>> = await axiosInstance.put(url, data, config);
    return response.data.data;
  }

  /**
   * PATCH request
   */
  async patch<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
    const response: AxiosResponse<ApiResponse<T>> = await axiosInstance.patch(url, data, config);
    return response.data.data;
  }

  /**
   * DELETE request
   */
  async delete<T = any>(url: string, config?: AxiosRequestConfig): Promise<T> {
    const response: AxiosResponse<ApiResponse<T>> = await axiosInstance.delete(url, config);
    return response.data.data;
  }
}

export const apiClient = new ApiClient();
export default apiClient;
